import Reveal from "@/components/Reveal";
import { Icon } from "@/components/Icon";
import { WHY_CHOOSE_US } from "@/lib/content";

const WhyChooseUs = () => {
  return (
    <section id="why-choose-us" className="bg-white scroll-mt-24" data-testid="why-choose-us">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24 lg:py-28">
        <Reveal className="max-w-2xl">
          <p className="text-[13px] font-semibold uppercase tracking-[0.18em] text-[#4B5CAB]">
            Why choose us
          </p>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-bold tracking-[-0.02em] text-[#2A2E7A] leading-[1.15]">
            The reasons Aruban businesses trust Best Bizz Financial
          </h2>
        </Reveal>

        <div className="mt-14 divide-y divide-[#2A2E7A]/8 border-y border-[#2A2E7A]/8">
          {WHY_CHOOSE_US.map((f, i) => (
            <Reveal key={f.title} delay={i * 0.06}>
              <div
                data-testid={`why-card-${i + 1}`}
                className="group grid grid-cols-1 sm:grid-cols-[auto,minmax(0,18rem),1fr] items-center gap-4 sm:gap-8 py-7 transition-colors duration-200"
              >
                <div className="flex items-center gap-5">
                  <span className="font-heading text-sm font-semibold text-[#4B5CAB]/70 tabular-nums w-6">
                    0{i + 1}
                  </span>
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[8px] bg-[#F5F6FB] border border-[#2A2E7A]/8 transition-colors duration-300 group-hover:bg-[#2A2E7A]">
                    <Icon
                      name={f.icon}
                      className="h-5 w-5 text-[#4B5CAB] transition-colors duration-300 group-hover:text-white"
                      strokeWidth={1.6}
                    />
                  </span>
                </div>
                <h3 className="font-heading text-lg font-semibold text-[#2A2E7A] tracking-[-0.01em]">
                  {f.title}
                </h3>
                <p className="text-[15px] text-[#51607A] leading-[1.7]">{f.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
